import styled from '@emotion/styled';
import { mediaQuery } from '@presentation/styles';

export const StyledLink = styled.div`
  font-weight: 400;

  display: block;
  width: 33.3%;
  padding-right: 10px;
  margin-bottom: 5px;

  &:hover {
    text-decoration: underline;
  }
  ${mediaQuery('medium')} {
    width: 50%;
  }
  ${mediaQuery('phone')} {
    width: 100%;
  }
`;
